import React from 'react';
import { useDarkClasses } from '../../hooks/useDarkClasses';
import { useRoleTheme } from '../../hooks/useRoleTheme';
interface SettingsSectionProps {
  icon: React.ReactNode;
  title: string;
  subtitle: string;
  headerRight?: React.ReactNode;
  children: React.ReactNode;
}
export const SettingsSection: React.FC<SettingsSectionProps> = ({
  icon,
  title,
  subtitle,
  headerRight,
  children
}) => {
  const dk = useDarkClasses();
  const rt = useRoleTheme();
  return <div data-id="element-627" data-mp="27j0nez60b3rf">
      <div className={`px-6 py-4 border-b ${dk.border}`} data-id="element-628" data-mp="22mjw5w3ig9a4">
        <div className="flex items-center justify-between" data-id="element-629" data-mp="22kz185daaobq">
          <div className="flex items-center" data-id="element-630" data-mp="1yjx17mbjm88p">
            <div className={`p-2 rounded-lg mr-3 ${rt.bgMedium}`} data-id="element-631" data-mp="1ymsxz7bnmqvk">{icon}</div>
            <div data-id="element-632" data-mp="1tn6l4yzqncna">
              <h3 className={`text-lg font-semibold ${dk.textHeading}`} data-id="element-633" data-mp="1tnoqcl4dp17c">
                {title}
              </h3>
              <p className={`text-sm ${dk.textMuted}`} data-id="element-634" data-mp="3swdev86o4onl">{subtitle}</p>
            </div>
          </div>
          {headerRight}
        </div>
      </div>
      <div className="p-6 space-y-6" data-id="element-635" data-mp="3hdne09x4chwj">{children}</div>
    </div>;
};